import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import MainSelectionPage from "./pages/MainSelectionPage";
import BrandsPortalPage from "./pages/BrandsPortalPage";
import BrandDetailPage from "./pages/BrandDetailPage";
import SourcesPortalPage from "./pages/SourcesPortalPage";
import SourceDetailPage from "./pages/SourceDetailPage";
import HistoryPage from "./pages/HistoryPage";
import HistoryPeriodPage from "./pages/HistoryPeriodPage";
import PriceListPage from "./pages/PriceListPage";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainSelectionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brands"
            element={
              <ProtectedRoute>
                <BrandsPortalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brands/:brandId"
            element={
              <ProtectedRoute>
                <BrandDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sources"
            element={
              <ProtectedRoute>
                <SourcesPortalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sources/:sourceId"
            element={
              <ProtectedRoute>
                <SourceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <HistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history/:periodId"
            element={
              <ProtectedRoute>
                <HistoryPeriodPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/price-list"
            element={
              <ProtectedRoute>
                <PriceListPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
